export default "__VITE_ASSET__DznMpZSa__"